import { render, staticRenderFns } from "./MyProspectList.vue?vue&type=template&id=f92461e0"
import script from "./MyProspectList.vue?vue&type=script&lang=js"
export * from "./MyProspectList.vue?vue&type=script&lang=js"
import style0 from "./MyProspectList.vue?vue&type=style&index=0&id=f92461e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports